import { retrieveUsers } from './userActions'
import { retrievePromoCodes } from './promoCodesActions'
import {retrieveCardsAction} from "../../modules/card/model/cardActions";

export const setDefaultUserData = () => dispatch => {
	dispatch(retrieveCardsAction({ page: 1 }))
}